import Howler from 'howler';
import SettingsStore from '~/flux/stores/SettingsStore';

Howler.autoSuspend = false;
const { Howl } = Howler;

const { ASSETS_PATH = 'assets' } = process.env;
const AUDIO_PATH = `${ASSETS_PATH}/audio`;

const SOUND_DEFS = {
  // background music & ambience
  menu_music: {
    src: [`${AUDIO_PATH}/bg/menu_music.mp3`],
    loop: true,
  },
  reverse_tibetan_chant: {
    src: [`${AUDIO_PATH}/bg/reverse_tibetan_chant_soft.mp3`],
    loop: true,
  },
  reverse_tibetan_chant_02: {
    src: [`${AUDIO_PATH}/bg/reverse_tibetan_chant_soft.mp3`],
  },
  reverse_tibetan_chant_03: {
    src: [`${AUDIO_PATH}/bg/reverse_tibetan_chant_soft.mp3`],
  },
  battle_music: {
    src: [`${AUDIO_PATH}/bg/battle_music.mp3`],
    loop: true,
  },
  caverns_theme: {
    src: [`${AUDIO_PATH}/bg/caverns_theme_96kbps.mp3`],
    loop: true,
  },

  // ui effects
  click: { src: [`${AUDIO_PATH}/ui/click.mp3`] },
  star_twinkle: { src: [`${AUDIO_PATH}/ui/star_twinkle_01.mp3`] },
  electric_smash: {
    src: [`${AUDIO_PATH}/ui/electric_smash_96kbps.mp3`],
  },
  airy_magic_whoosh: {
    src: [`${AUDIO_PATH}/ui/airy_magic_whoosh.mp3`],
  },
  equipment_storage: {
    src: [`${AUDIO_PATH}/ui/equipment_storage.mp3`],
  },
  coin_rattle: { src: [`${AUDIO_PATH}/ui/coin_rattle.mp3`] },
  register_ding: { src: [`${AUDIO_PATH}/ui/register_ding.mp3`] },
  level_up: { src: [`${AUDIO_PATH}/ui/level_up_02.mp3`] },
  crystal_twinkle: {
    src: [`${AUDIO_PATH}/ui/crystal_twinkle_small.mp3`],
  },

  // battle effects
  sandstone_step_6: {
    src: [`${AUDIO_PATH}/unit_actions/general/sandstone_step_6.mp3`],
  },
  sandstone_step_46: {
    src: [`${AUDIO_PATH}/unit_actions/general/sandstone_step_46.mp3`],
  },
  melee_attack_04: {
    src: [`${AUDIO_PATH}/unit_actions/general/melee_attack_04.mp3`],
  },
  melee_attack_12: {
    src: [`${AUDIO_PATH}/unit_actions/general/melee_attack_12.mp3`],
  },
  melee_attack_14: {
    src: [`${AUDIO_PATH}/unit_actions/general/melee_attack_14.mp3`],
  },
  melee_attack_19: {
    src: [`${AUDIO_PATH}/unit_actions/general/melee_attack_19.mp3`],
  },
  dagger_clang: {
    src: [`${AUDIO_PATH}/unit_actions/general/dagger_clang.mp3`],
  },
  sword_clang: {
    src: [`${AUDIO_PATH}/unit_actions/general/sword_clang.mp3`],
  },
  dodge: { src: [`${AUDIO_PATH}/unit_actions/general/dodge_2.mp3`] },
  throw_01: {
    src: [`${AUDIO_PATH}/unit_actions/general/throw_01.mp3`],
  },
  glass_shatter_01: {
    src: [`${AUDIO_PATH}/unit_actions/general/glass_shatter_01_96kbps.mp3`],
  },
  thump_02: {
    src: [`${AUDIO_PATH}/unit_actions/general/thump_02_96kbps.mp3`],
  },
  body_fall_01: {
    src: [`${AUDIO_PATH}/unit_actions/general/body_fall_dirt_01_96kbps.mp3`],
  },
  block: {
    src: [`${AUDIO_PATH}/unit_actions/general/block_03_96kbps.mp3`],
  },
  unit_death: {
    src: [`${AUDIO_PATH}/unit_actions/general/unit_death.mp3`],
  },
  option_attack: {
    src: [`${AUDIO_PATH}/unit_actions/general/option_attack_04_96kbps.mp3`],
  },

  // alchemy
  burning_hands: {
    src: [`${AUDIO_PATH}/unit_actions/alchemy/burning_hands_01.mp3`],
  },
  fumigate: {
    src: [`${AUDIO_PATH}/unit_actions/alchemy/fumigate_final_96kbps.mp3`],
  },
  ice_nine: {
    src: [`${AUDIO_PATH}/unit_actions/alchemy/ice_nine_01_96kbps.mp3`],
  },
  poison_weapon: {
    src: [`${AUDIO_PATH}/unit_actions/alchemy/poison_weapon_05_96kbps.mp3`],
  },
  lightning: {
    src: [`${AUDIO_PATH}/unit_actions/alchemy/lightning_01_96kbps.mp3`],
  },

  // armor use
  suture: {
    src: [`${AUDIO_PATH}/unit_actions/armor_use/suture_01_96kbps.mp3`],
  },

  // bow use
  fire_bow: {
    src: [`${AUDIO_PATH}/unit_actions/bow_use/fire_bow.mp3`],
  },
  arrow_hit_01: {
    src: [`${AUDIO_PATH}/unit_actions/bow_use/arrow_hit_01.mp3`],
  },
  arrow_hit_02: {
    src: [`${AUDIO_PATH}/unit_actions/bow_use/arrow_hit_02.mp3`],
  },
  arrow_hit_03: {
    src: [`${AUDIO_PATH}/unit_actions/bow_use/arrow_hit_03.mp3`],
  },
  chain_pull: {
    src: [`${AUDIO_PATH}/unit_actions/bow_use/chain_pull_01_96kbps.mp3`],
  },
  chain_pull_02: {
    src: [`${AUDIO_PATH}/unit_actions/bow_use/chain_pull_02_96kbps.mp3`],
  },

  // conjuration
  summon_04: {
    src: [`${AUDIO_PATH}/unit_actions/conjuration/summon_04_96kbps.mp3`],
  },
  void_spike_03: {
    src: [`${AUDIO_PATH}/unit_actions/conjuration/void_spike_03.mp3`],
  },

  // illusion
  devil_mask_01: {
    src: [`${AUDIO_PATH}/unit_actions/illusion/devil_mask_01.mp3`],
  },
  evil_laugh_01: {
    src: [`${AUDIO_PATH}/unit_actions/illusion/evil_laugh_01.mp3`],
  },
  antidote_02: {
    src: [`${AUDIO_PATH}/unit_actions/illusion/antidote_02_96kbps.mp3`],
  },
  magic_wave: {
    src: [`${AUDIO_PATH}/unit_actions/illusion/magic_wave.mp3`],
  },

  // melee_combat
  roundhouse: {
    src: [`${AUDIO_PATH}/unit_actions/melee_combat/roundhouse.mp3`],
  },
  slash: {
    src: [`${AUDIO_PATH}/unit_actions/melee_combat/slash_96kbps.mp3`],
  },
  armor_break: {
    src: [`${AUDIO_PATH}/unit_actions/melee_combat/armor_break_03_96kbps.mp3`],
  },

  // movement
  leap: {
    src: [`${AUDIO_PATH}/unit_actions/movement/leap_01_96kbps.mp3`],
  },

  // spirit
  send_mana: {
    src: [`${AUDIO_PATH}/unit_actions/spirit/send_mana_01_96kbps.mp3`],
  },
  bless: {
    src: [`${AUDIO_PATH}/unit_actions/spirit/bless_02_96kbps.mp3`],
  },
  positive_magic_01: {
    src: [`${AUDIO_PATH}/unit_actions/spirit/positive_magic_01_96kbps.mp3`],
  },
  mystic_focus: {
    src: [`${AUDIO_PATH}/unit_actions/spirit/mystic_focus_03_96kbps.mp3`],
  },
};

const sounds = {};

function ensureInit(soundKey) {
  if (sounds[soundKey]) return;
  sounds[soundKey] = new Howl(SOUND_DEFS[soundKey]);
}

let currentBGTrack = null;
let musicVolume = SettingsStore.getAll().musicVolume;
let sfxVolume = SettingsStore.getAll().sfxVolume;

const HALF_STEP = 1 / 12;

const Audio = {
  play: (sound, isMusic = false) => {
    try {
      ensureInit(sound);
      var audio = sounds[sound];
      if (!audio) {
        return;
      }

      audio.seek(0);
      audio.volume(isMusic ? musicVolume : sfxVolume);

      let sprite = audio.play();

      // fun
      switch (sound) {
        case 'bless':
        case 'positive_magic_01': {
          // D major
          const rate_val = (() => {
            const rand = Math.floor(Math.random() * 7);
            switch (rand) {
              case 0:
                return 0.5;
              case 1:
                return 0.5 + HALF_STEP * 2;
              case 2:
                return 0.5 + HALF_STEP * 4;
              case 3:
                return 0.5 + HALF_STEP * 5;
              case 4:
                return 0.5 + HALF_STEP * 7;
              case 5:
                return 0.5 + HALF_STEP * 9;
              case 6:
                return 0.5 + HALF_STEP * 11;
            }
          })();
          audio.rate(rate_val, sprite);
          break;
        }

        case 'mystic_focus':
        case 'magic_wave':
        case 'melee_attack_04':
        case 'melee_attack_12':
        case 'melee_attack_14':
        case 'melee_attack_19':
        case 'dagger_clang':
        case 'sword_clang':
        case 'dodge':
        case 'throw_01':
        case 'thump_02':
        case 'body_fall_01':
        case 'block':
        case 'unit_death':
        case 'option_attack':
        case 'burning_hands':
        case 'poison_weapon':
        case 'lightning':
        case 'arrow_hit_01':
        case 'arrow_hit_02':
        case 'arrow_hit_03':
        case 'void_spike_03':
        case 'antidote_02':
        case 'roundhouse': {
          // random rate mod
          audio.rate(0.75 + Math.random() * 0.5, sprite);
          break;
        }
      }
    } catch (err) {
      logError(err, {
        module: 'Audio',
        func: 'play',
        sound,
        isMusic,
      });
    }
  },

  stop: (sound) => {
    if (sounds[sound]) {
      sounds[sound].pause();
    }
  },

  setBGTrack: (sound) => {
    if (currentBGTrack === sound) {
      return;
    }

    Audio.stop(currentBGTrack);

    if (sound) {
      ensureInit(sound);
      Audio.play(sound, true);
      sounds[sound].loop = true;
    }

    currentBGTrack = sound;
  },

  setMusicVolume: (value) => {
    musicVolume = value;

    if (sounds[currentBGTrack]) {
      sounds[currentBGTrack].volume(musicVolume);
    }
  },

  setSFXVolume: (value) => {
    sfxVolume = value;
    Audio.play('bless');
  },

  getMusicVolume: () => {
    return musicVolume;
  },

  getSFXVolume: () => {
    return sfxVolume;
  },
};

// mute when the game is not in focus
let music_buf = parseFloat(localStorage.getItem('dt_musicVolume'), 10);
let sfx_buf = parseFloat(localStorage.getItem('dt_sfxVolume'), 10);
document.addEventListener('visibilitychange', () => {
  if (document.hidden || document.webkitHidden) {
    music_buf = Audio.getMusicVolume();
    sfx_buf = Audio.getSFXVolume();
    Audio.setMusicVolume(0);
    Audio.setSFXVolume(0);
  } else {
    Audio.setMusicVolume(music_buf || 0);
    Audio.setSFXVolume(sfx_buf || 0);
  }
});

export default Audio;
